import { useProjectTreeStore } from 'store/projectContract.store';

import DataStoriesPage from 'components/pages/DataStoriesPage/DataStoriesPage';

export const RenderProjectDataStories = () => {
    const { project, contract } = useProjectTreeStore();
    return <DataStoriesPage project={project} contract={contract} />;
};
